import type { LogItemProps } from './LogItem.types';

const LogItem = ({ label, value }: LogItemProps) => {
  return (
    <div className="flex flex-row items-center gap-2 flex-wrap  pr-2.5 pl-0">
      <span className="text-[14px] text-neutral-400 font-normal break-all">{label}</span>
      <span className="text-[14px] font-medium break-all">{value}</span>
    </div>
  );
};

export default LogItem;
